export class UserLeftMenu {
    employeeId: any;
    firstName: any;
    lastName: any;
    designationName: any;
    profilePicPath: any;
    gender: any;
}